import { GET, POST } from '.'

export type WebhookEventListRow = {
  id: string
  doctype: string
  erpnextDocName: string
  status: string
  errorMessage: string | null
  attempts: number
  createdAt: string | null
  processedAt: string | null
}

export type WebhookEventDetail = WebhookEventListRow & {
  payload: unknown
}

export type WebhookEventStats = {
  since: string
  queueDepth: Array<{ status: string; count: number }>
  byDoctype: Array<{ doctype: string; status: string; count: number }>
  recentFailures: Array<{
    id: string
    doctype: string
    erpnextDocName: string
    errorMessage: string | null
    createdAt: string | null
  }>
  processingRate: {
    eventsPerHour: number
    avgProcessingMs: number
  }
}

export type WebhookEventStatus =
  | 'pending'
  | 'processing'
  | 'completed'
  | 'failed'
  | 'skipped'

export const listFailed = (params: {
  limit?: number
  offset?: number
  doctype?: string
}): Promise<{ events: WebhookEventListRow[]; total: number }> =>
  GET('/admin/webhook-events/failed', { params })

export const getDetail = (id: string): Promise<{ event: WebhookEventDetail }> =>
  GET(`/admin/webhook-events/${id}`)

export const retry = (
  id: string,
): Promise<{ event: { id: string; status: string; attempts: number } }> =>
  POST(`/admin/webhook-events/${id}/retry`, {})

export const skip = (
  id: string,
  reason: string,
): Promise<{
  event: { id: string; status: string; errorMessage: string | null }
}> => POST(`/admin/webhook-events/${id}/skip`, { reason })

export const getStats = (params?: {
  since?: string
}): Promise<WebhookEventStats> => GET('/admin/webhook-events/stats', { params })

export const listRecent = (params: {
  limit?: number
  offset?: number
  status?: WebhookEventStatus
  doctype?: string
}): Promise<{ events: WebhookEventListRow[]; total: number }> =>
  GET('/admin/webhook-events/recent', { params })
